var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQuit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 22,
    viewBox: "0 0 88 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    clipPath: "url(#clip0_12_629)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.41016 3H9.41016V11H7.41016V3ZM11.4102 3.59375L11.457 3.60938C12.1862 3.91146 12.8529 4.3099 13.457 4.80469C14.0612 5.29948 14.582 5.86719 15.0195 6.50781C15.457 7.14844 15.7982 7.84896 16.043 8.60938C16.2878 9.36979 16.4102 10.1667 16.4102 11C16.4102 12.1042 16.2018 13.1432 15.7852 14.1172C15.3685 15.0911 14.7982 15.9401 14.0742 16.6641C13.3503 17.388 12.5013 17.9583 11.5273 18.375C10.5534 18.7917 9.51432 19 8.41016 19C7.30599 19 6.26693 18.7917 5.29297 18.375C4.31901 17.9583 3.47005 17.388 2.74609 16.6641C2.02214 15.9401 1.45182 15.0911 1.03516 14.1172C0.61849 13.1432 0.410156 12.1042 0.410156 11C0.410156 10.1667 0.532552 9.36979 0.777344 8.60938C1.02214 7.84896 1.36328 7.14844 1.80078 6.50781C2.23828 5.86719 2.76432 5.29688 3.37891 4.79688C3.99349 4.29688 4.67057 3.89583 5.41016 3.59375L5.37891 5.82812C4.94141 6.08854 4.53776 6.40104 4.16797 6.76562C3.79818 7.13021 3.48307 7.53385 3.22266 7.97656C2.96224 8.41927 2.76172 8.89583 2.62109 9.40625C2.48047 9.91667 2.41016 10.4479 2.41016 11C2.41016 11.8333 2.56641 12.6146 2.87891 13.3438C3.19141 14.0729 3.62109 14.7083 4.16797 15.25C4.71484 15.7917 5.35026 16.2188 6.07422 16.5312C6.79818 16.8438 7.57682 17 8.41016 17C9.24349 17 10.0221 16.8438 10.7461 16.5312C11.4701 16.2188 12.1055 15.7917 12.6523 15.25C13.1992 14.7083 13.6289 14.0729 13.9414 13.3438C14.2539 12.6146 14.4102 11.8333 14.4102 11C14.4102 10.4479 14.3398 9.91667 14.1992 9.40625C14.0586 8.89583 13.8555 8.41927 13.5898 7.97656C13.3242 7.53385 13.0065 7.1276 12.6367 6.75781C12.2669 6.38802 11.8581 6.07292 11.4102 5.8125V3.59375Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12_629"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0.410156 3)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuit);
export default __webpack_public_path__ + "static/media/quit.ee1cd7c32553bcf432719b90b78ca4eb.svg";
export { ForwardRef as ReactComponent };